module.exports = __webpack_public_path__ + "ef298ca512075561f621fbf908afb5ef.woff2";